import {MatPaginatorIntl} from '@angular/material/paginator';

export function ruPaginatorIntl(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();
  intl.itemsPerPageLabel = 'Элементов на странице:';
  intl.nextPageLabel = 'Следующая страница';
  intl.previousPageLabel = 'Предыдущая страница';
  intl.firstPageLabel = 'Первая страница';
  intl.lastPageLabel = 'Последняя страница';
  intl.getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 из ${length}`;
    }
    const total = Math.max(length, 0);
    const start = page * pageSize;
    const end = start < total
      ? Math.min(start + pageSize, total)
      : start + pageSize;
    return `${start + 1} – ${end} из ${total}`;
  };
  return intl;
}
